module.exports = __webpack_public_path__ + "media/customizations/jubilee/back-26ad37e1e900a32fdd5077ed4e030e55.jpg";